import { logger } from '@/lib/logging'
import type { SessionRefs } from './types'

export function createMixedAudioStream(
  refs: SessionRefs,
  screenStream: MediaStream,
  showNotification: (message: string) => void
): MediaStream | null {
  const screenAudioTracks = screenStream.getAudioTracks()
  if (screenAudioTracks.length === 0 || !refs.mediaStreamRef.current) return null

  logger.info('System audio detected, initializing audio mixing')

  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext
    const audioCtx = new AudioContextClass()
    refs.audioMixingContextRef.current = audioCtx

    const dest = audioCtx.createMediaStreamDestination()
    audioCtx.createMediaStreamSource(refs.mediaStreamRef.current).connect(dest)
    audioCtx.createMediaStreamSource(screenStream).connect(dest)

    refs.mixedAudioStreamRef.current = dest.stream
    logger.info('Audio mixing initialized successfully')
    return dest.stream
  } catch (err) {
    logger.error('Failed to mix audio', { error: String(err) })
    showNotification('Failed to mix system audio - using microphone only')
    return null
  }
}
